var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7027 3.4054C0.754882 3.4054 0 2.63919 0 1.7027C0 0.766216 0.766216 0 1.7027 0C2.63919 0 3.4054 0.766216 3.4054 1.7027C3.4054 2.63919 2.65052 3.4054 1.7027 3.4054ZM0 8.51349C0 9.45567 0.760522 10.2162 1.7027 10.2162C2.64488 10.2162 3.4054 9.45567 3.4054 8.51349C3.4054 7.57131 2.64488 6.81079 1.7027 6.81079C0.760522 6.81079 0 7.57131 0 8.51349ZM0 15.3243C0 16.2665 0.760522 17.027 1.7027 17.027C2.64488 17.027 3.4054 16.2665 3.4054 15.3243C3.4054 14.3821 2.64488 13.6216 1.7027 13.6216C0.760522 13.6216 0 14.3821 0 15.3243ZM5.10815 2.83778H21V0.567492H5.10815V2.83778ZM21 16.4594H5.10815V14.1891H21V16.4594ZM5.10815 9.64857H21V7.37828H5.10815V9.64857Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList);
export default __webpack_public_path__ + "static/media/view-list.e11bc3b5c2a019c138a05b33be20bc3b.svg";
export { ForwardRef as ReactComponent };